import { FormHelperText } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import { RichTextEditor } from 'components/RichTextEditor';

type InternalNotesInputProps = {
  initialValue: string;
};

const useStyles = makeStyles()(() => ({
  editor: {
    minHeight: 42,
  },
}));

export const InternalNotesInput = (
  props: InternalNotesInputProps,
): JSX.Element => {
  const { initialValue } = props;
  const { classes } = useStyles();
  const { t } = useTranslation();
  const { control, formState } = useFormContext();

  return (
    <Controller
      name="reporterOnlyNotes"
      control={control}
      render={({ field, fieldState }): JSX.Element => {
        return (
          <div>
            <RichTextEditor
              id="field-control-internal-notes"
              data-testid="reporter-only-notes"
              label={t('createEditWildfire.inputs.reporterOnlyNotes.label')}
              initialValue={initialValue}
              onChange={field.onChange}
              editable={!formState.isSubmitting}
              error={Boolean(fieldState.error)}
              editorClassName={classes.editor}
              onBlur={field.onBlur}
            />
            <FormHelperText
              error={Boolean(fieldState.error)}
              sx={{ mx: 1.75, mt: 0.5 }}
            >
              {fieldState.error?.message ||
                t('createEditWildfire.inputs.reporterOnlyNotes.helperText')}
            </FormHelperText>
          </div>
        );
      }}
    />
  );
};
